module.exports = __webpack_public_path__ + "bcf5029113fa9efaca30dd6695669133.png";